<template>
	<div class="swiper">
		<div class="swiper-container" :class="swipeid">
			<div class="swiper-wrapper">
				<!-- 存放具体的轮播内容 -->
				<slot name ="swiper-con"></slot>
			</div>
		</div>
		<!-- 分页器 -->
		<div :class="{'swiper-pagination':pagination}"></div>
	</div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css';
export default {
	name: 'Swiper',
	props: {
		swipeid: {
			type: String,
			default: ''
		},
		effect: {
			type: String,
			default: 'slide'
		},
		loop: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: 'horizontal'
		},
		pagination: {
			type: Boolean,
			default: true
		},
		paginationType: {
			type: String,
			default: 'bullets'
		},
		autoPlay: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			dom: ''
		};
	},
	methods: {
	},
	created () {
	},
	mounted () {
		let that = this;
		that.dom = new Swiper('.' + that.swipeid, {
			// 循环
			// loop: that.loop,
			// 分页器
			pagination: {
				el: '.swiper-pagination',
				bulletClass: 'swiper-pagination-bullet'
			},
			// 分页类型
			paginationType: that.paginationType,
			// 自动播放
			autoplay: that.autoPlay,
			// 方向
			direction: that.direction,
			// 特效
			effect: that.effect,
			// 用户操作swiper之后，不禁止autoplay
			disableOnInteraction: false,
			// 修改swiper自己或子元素时，自动初始化swiper
			observer: true,
			// 修改swiper的父元素时，自动初始化swiper
			observeParents: true
		});
	}
};
</script>
<style>
	.swiper-container {
		width: 100%;
		height: 1.6rem;
	}
	.swiper__slide--img{
		width: 100%;
		height: 1.6rem;
		display: block;
		background: url(../assets/images/img-loading.png) no-repeat center center;
		background-size: 0.8rem auto;

	}
	.swiper__slide--img img{
		display: block;
        width: 100%;
        height: auto;
	}
	.swiper-pagination{
		font-size: 0;
		padding: 0.11rem;
        margin-bottom: 0.12rem;
        position: relative;
	}
	.swiper-pagination-bullet{
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #004C87;
		margin: 0 0.08rem;
	}
	.swiper-pagination-bullet-active{
		background: #004C87;
	}
</style>
